import { contains } from '@utils/string'

/**
 * Helper common method to add the tailwind class `!tw-z-modal`
 * to any visible if it doesn't already have it.
 *
 * @param {string} key elementId value of the expected bvModal, `i.e: modal-id___FB_modal_outer_`
 *
 * @example `@shown="checkVisibility('modal-id___FB_modal_outer_')"`
 */
export function checkVisibility(key){
  // check / confirm that the modal has the correct z-index
  const modalWrapper = document.getElementById(key)
  if (modalWrapper && !contains(modalWrapper.className, '!tw-z-modal')){
    modalWrapper.className += ' !tw-z-modal';
  }
}
